export interface DefinitionBlockItem {
  definition: string;
  value: string;
}

export interface DefinitionBlockProps {
  title: string;
  icon?: React.ReactElement;
  items: DefinitionBlockItem[]
}

function DefinitionBlock(props: DefinitionBlockProps) {
  const { title, icon, items } = props;
  return (
    <div className="ct_definitionBlock">
      <div className="ct_definitionBlock-head">
        {!!icon && (
          <div className="ct_definitionBlock-icon">
            {icon}
          </div>
        )}
        <div className="ct_definitionBlock-title">{title}</div>
      </div>
      <ul className="ct_definitionBlock-list">
        {!!items && items.length && items.map((item, index) => (
          <li key={index} className="ct_definitionBlock-listItem">
            <div>{item.definition}</div>
            <div>{item.value}</div>
          </li>
        ))}
      </ul>
    </div>
  );
}

DefinitionBlock.defaultProps = { ...{} };

export default DefinitionBlock;
